module.exports = __webpack_public_path__ + "fonts/arialroundedmtbold.200135e8.ttf";